// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"3ffa6c36","517":"e53ecd2b","2715":"3ffa6c36","9593":"17d52986"}[chunkId] + ".chunk.css";
};